import { useState } from 'react';

import { Loader, Trash } from 'lucide-react';

import { deleteFile } from '@/api/cases';

import { Button } from '@/components/ui/button';

type ImagesListProps = {
  caseId: string;
  images: File[];
  onRemoveImage: (fileName: string) => void;
  disabled?: boolean;
};

export function ImagesList(props: ImagesListProps) {
  const { images, onRemoveImage, caseId, disabled } = props;
  const [deletingFile, setDeletingFile] = useState<string[]>([]);

  const handleFileDelete = async (fileName: string) => {
    setDeletingFile((prev) => [...prev, fileName]);

    try {
      await deleteFile(caseId, fileName);
      onRemoveImage(fileName);
    } finally {
      setDeletingFile((prev) => prev.filter((file) => file !== fileName));
    }
  };

  return (
    <div className="grid grid-cols-2 gap-4 mb-8">
      {images.map((image, index) => {
        const isDeleting = deletingFile.includes(image.name);
        return (
          <div key={index} className="flex flex-col items-center">
            <img
              src={URL.createObjectURL(image)}
              alt={`Image ${index + 1}`}
              className="w-full h-auto rounded-lg shadow-md"
            />
            <div className="flex justify-between w-full mt-2 px-2">
              <p className="mt-2 text-sm text-gray-600">{image.name}</p>
              <Button
                variant="destructive"
                size="icon"
                disabled={isDeleting || disabled}
                onClick={() => void handleFileDelete(image.name)}
              >
                {isDeleting ? <Loader className="animate-spin" /> : <Trash />}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
